<template>
  <v-main>
    <div class="d-flex w-full h-full pa-0">
      <OLoadingDialog :value="isLoading" />

      <div class="w-250 border-gray border-r-1 bg-gray grow-0 shrink-0">
        <SidebarHeaders :headers="headers" class="mt-1 pa-2" />

        <DesktopSideBar :tabItems="tabItems" :currentTab.sync="currentTab" />
      </div>

      <!-- w-0 é um WTF, vide layout.sass -->
      <div class="w-0 grow-1">
        <TabContainer
          v-if="row != null"
          @reload="reload"
          :tabItems="tabItems"
          :currentTab="currentTab"
          :value="row"
        />
      </div>
    </div>
  </v-main>
</template>

<script>
import SidebarHeaders from 'oderon-vue/cpts/tabbed-interface/SidebarHeaders.vue'
import DesktopSideBar from 'oderon-vue/cpts/tabbed-interface/DesktopSideBar.vue'
import TabContainer from 'oderon-vue/cpts/tabbed-interface/TabContainer.vue'
import EditStore from './EditStore'

export default {
  components: {
    DesktopSideBar,
    TabContainer,
    SidebarHeaders
  },
  props: {
    id: { required: true }
  },
  watch: {
    id() {
      this.reload()
    }
  },
  data() {
    return { isLoading: false }
  },
  computed: {
    currentTab: {
      get() {
        return EditStore.currentTab
      },
      set(x) {
        EditStore.currentTab = x
      }
    },
    row() {
      return EditStore.row
    },
    isDirty() {
      return EditStore.isDirty
    },
    subtitle() {
      const id = this.row && this.row.id
      const serial = this.row && this.row.imei
      if (id == null || serial == null) return null
      return `ID #${this.row.id} ─ Serial ${this.row.serial}`
    },
    tabItems() {
      return EditStore.tabItems
    },
    headers() {
      let { name, serial, vehicle } = this.row || {}

      let vcode = vehicle && vehicle.code
      let vid = vehicle && vehicle.id

      let result = [
        { icon: 'mdi-keypad', text: name, primary: true },
        {
          icon: 'mdi-developer-board',
          text: serial
        },
        {
          icon: 'mdi-car',
          text: vcode || '(sem placa)',
          action: vid == null ? '' : '#' + vid
        }
      ]

      return result
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$loading(() => EditStore.load(this.id))
    }
  }
}
</script>

<style lang="sass"></style>
